<template>
  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;" v-loading="loading">
      <el-col :span="20">
        <el-form ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="角色名称" prop="name" >
            <el-input v-model="name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="可操作权限" prop="name" >
            <el-tree :data="menuData" size="mini" show-checkbox node-key="id" :props="defaultProps"
               style="width: 100%;pading-top:20px;" ref="menuTree" :render-content="renderContent">
            </el-tree>
            <div style="float:left;padding-left:24px;padding-top:12px;padding-bottom:4px;">
              <el-checkbox v-model="checkAll" @change="handleCheckAll"><b>全选</b></el-checkbox>
            </div>
          </el-form-item>

          <div class="but_bot">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import { getMenuData,getroleAdd } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        menuData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        name: '',
        checkAll:false,
        loading:false
      }
    },
    components: {
      headTop
    },
    methods:{
      //菜单列表
      getMenuData(){
        getMenuData().then((res)=>{
          this.menuData = res
          res.forEach(element => {
            element.children.forEach(elements => {
              elements.name=elements.name.replace("2","");
            });
          });
        }).catch(error=>{

        })
      },
      renderContent(h, { node, data, store }) {
        return (
          <div class="column-container">
          <span style="text-algin:center;margin-right:80px;">{data.name}</span>

          </div>);
      },
      // 全选操作
      handleCheckAll() {
        if(this.checkAll) {
          let allMenus = []
          this.checkAllMenu(this.menuData, allMenus)
          this.$refs.menuTree.setCheckedNodes(allMenus)
        } else {
          this.$refs.menuTree.setCheckedNodes([])
        }
      },
      // 递归全选
      checkAllMenu(menuData, allMenus) {
        menuData.forEach(menu => {
          allMenus.push(menu)
          if(menu.children) {
            this.checkAllMenu(menu.children, allMenus)
          }
        });
      },
    //  提交
      submit(){
        if (this.name == ''){
          this.$message({message: '请输入角色名称！', type: 'error'})
          return
        }
        let roleId = JSON.parse(sessionStorage.getItem('user')).roleId
        let checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)
        let roleMenus = []
        for(let i=0, len=checkedNodes.length; i<len; i++) {
          let roleMenu = { menuId:checkedNodes[i].id, operationId: JSON.parse(sessionStorage.getItem('user')).id }
          roleMenus.push(roleMenu)
        }
        if(roleMenus.length == 0) {
          this.$message({message: '至少添加一个权限，不允许为空！', type: 'error'})
          return
        }
        let params = {
          name:this.name,
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
          roleMenus:JSON.stringify(roleMenus),
        }
        getroleAdd(params).then((res)=>{
          if (res.state == true) {
            this.$message({
              type: 'success',
              message: res.msg
            });
            this.loading = false
            this.reload()
            this.$router.push('privilege')
          }else{
            this.$message({
              type: 'error',
              message: '请上传完整信息'
            });
            this.loading = false
          }
        }).catch(error=>{
          console.log(error)
        })
      },
      //取消
      cancel(){
        this.reload()
        this.$router.push('privilege')
      },
    },
    computed: {
    },
    created () {
      this.getMenuData()
    },

  }
</script>
<style>
  .edit_container{
    padding: 40px;
    margin-bottom: 40px;
  }
  .editer{
    height: 300px;
  }
  .mar{
    margin-top:20px;
  }
  .upload-demo{
    width: 300px;
  }
</style>




// WEBPACK FOOTER //
// src/page/newprivilege.vue